module.exports = __webpack_public_path__ + "img/NJAJ.4b1e6cb6.jpg";